import { en, fi, sv, nbNO, da, nl, de, fr, es } from "vuejs-datepicker/dist/locale";
import moment from "moment";

const languageObjectsByLanguageCode: any = {
  en,
  fi,
  sv,
  da,
  nl,
  de,
  fr,
  es,
  nb: nbNO,
};

export const datepickerMixin = {
  methods: {
    prepareIconForBg(viewBox: string, svgPath: string, color: string): string {
      // prepare svg path color
      const path = svgPath.replace(/fill="currentColor"/g, `fill="${color}"`);
      const svg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='${viewBox}'>${path}</svg>`;
      return `data:image/svg+xml;base64,${btoa(svg)}`;
    },
    getLanguageObject(language: string): any {
      return languageObjectsByLanguageCode[language];
    },
    customFormatter(date: any): any {
      return moment(date).utc().format("D.M.YYYY");
    },
  },
};
